module.exports = __webpack_public_path__ + "img/carstock-grafico.599f51be.svg";